import { UserForm } from '@/components/enc/user-form';

const AddPage = () => <UserForm />;

export default AddPage;
